/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Purchase_Insufficient_Gems_TitleInputs */

const en_dialog_purchase_insufficient_gems_title = /** @type {(inputs: Dialog_Purchase_Insufficient_Gems_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not Enough Time Crystals`)
};

const ar_dialog_purchase_insufficient_gems_title = /** @type {(inputs: Dialog_Purchase_Insufficient_Gems_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بلورات الزمن غير كافية`)
};

const de_dialog_purchase_insufficient_gems_title = /** @type {(inputs: Dialog_Purchase_Insufficient_Gems_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu wenig Zeitkristalle`)
};

const es_dialog_purchase_insufficient_gems_title = /** @type {(inputs: Dialog_Purchase_Insufficient_Gems_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cristales de tiempo insuficientes`)
};

const fr_dialog_purchase_insufficient_gems_title = /** @type {(inputs: Dialog_Purchase_Insufficient_Gems_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cristaux temporels insuffisants`)
};

const it_dialog_purchase_insufficient_gems_title = /** @type {(inputs: Dialog_Purchase_Insufficient_Gems_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cristalli del Tempo insufficienti`)
};

const ja_dialog_purchase_insufficient_gems_title = /** @type {(inputs: Dialog_Purchase_Insufficient_Gems_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時の結晶が足りません`)
};

const ko_dialog_purchase_insufficient_gems_title = /** @type {(inputs: Dialog_Purchase_Insufficient_Gems_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`타임 크리스탈 부족`)
};

const pt_br_dialog_purchase_insufficient_gems_title = /** @type {(inputs: Dialog_Purchase_Insufficient_Gems_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cristais do Tempo insuficientes`)
};

const ru_dialog_purchase_insufficient_gems_title = /** @type {(inputs: Dialog_Purchase_Insufficient_Gems_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Недостаточно кристаллов времени`)
};

const th_dialog_purchase_insufficient_gems_title = /** @type {(inputs: Dialog_Purchase_Insufficient_Gems_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คริสตัลแห่งกาลเวลาไม่พอ`)
};

const tr_dialog_purchase_insufficient_gems_title = /** @type {(inputs: Dialog_Purchase_Insufficient_Gems_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yetersiz Zaman Kristali`)
};

const zh_cn_dialog_purchase_insufficient_gems_title = /** @type {(inputs: Dialog_Purchase_Insufficient_Gems_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时光宝石不足`)
};

const zh_tw_dialog_purchase_insufficient_gems_title = /** @type {(inputs: Dialog_Purchase_Insufficient_Gems_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時光寶石不足`)
};

/**
* | output |
* | --- |
* | "Not Enough Time Crystals" |
*
* @param {Dialog_Purchase_Insufficient_Gems_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_purchase_insufficient_gems_title = /** @type {((inputs?: Dialog_Purchase_Insufficient_Gems_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Purchase_Insufficient_Gems_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_purchase_insufficient_gems_title(inputs)
	if (locale === "ar") return ar_dialog_purchase_insufficient_gems_title(inputs)
	if (locale === "de") return de_dialog_purchase_insufficient_gems_title(inputs)
	if (locale === "es") return es_dialog_purchase_insufficient_gems_title(inputs)
	if (locale === "fr") return fr_dialog_purchase_insufficient_gems_title(inputs)
	if (locale === "it") return it_dialog_purchase_insufficient_gems_title(inputs)
	if (locale === "ja") return ja_dialog_purchase_insufficient_gems_title(inputs)
	if (locale === "ko") return ko_dialog_purchase_insufficient_gems_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_purchase_insufficient_gems_title(inputs)
	if (locale === "ru") return ru_dialog_purchase_insufficient_gems_title(inputs)
	if (locale === "th") return th_dialog_purchase_insufficient_gems_title(inputs)
	if (locale === "tr") return tr_dialog_purchase_insufficient_gems_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_purchase_insufficient_gems_title(inputs)
	return zh_tw_dialog_purchase_insufficient_gems_title(inputs)
});